export const TEASER_HOVER_DELAY = 450;
export const MAX_PROFILE_COUNT = 5;
export const VIDEO_FORMAT_360 = '360';
export const IOS_DEVICE = 'ios';
export const MAC_DEVICE = 'macOS';
export const DEFAULT_TEASER_LANE_PAGE_SIZE = 10;
export const SUPPORTED_IOS_VERSION = 15.1;
